import angular, { IWindowService } from "angular";
import { Ng1StateDeclaration, StateService, Transition } from "angular-ui-router";
import { configureStates, RouteDeclaration, addChildExtensions } from "../../../core/router/router-helper.provider";
import { AdpConfigService } from "../../../core/services/data-services/adp-config.service";
import { AdpImportFileExporterModal, ModalResult } from "./adp-import-file-exporter/adp-import-file-exporter-modal.component";
import { PayrollService } from "../../../core/services";

export const adpImportFileExporterState: Partial<Ng1StateDeclaration> = {
    name: "adpImportFileExporter",
    params: {
        payrollID: { type: "int" }
    },
    onEnter: ($uibModal: any, $state: StateService, $transition$: Transition, $window: IWindowService) => {
        'ngInject'
        const { payrollID } = $transition$.params();
        $uibModal.open({
            ...AdpImportFileExporterModal,
            resolve: {
                payrollID: () => payrollID,
                payroll: (payrollService: PayrollService) => {
                    'ngInject';
                    return payrollService.retrievePayroll
                },
                exportFormats: (adpConfigService: AdpConfigService) => {
                    'ngInject';
                    return adpConfigService.retrieveAdpExportFormats();
                },
                earningsCodeDefinitions: (adpConfigService: AdpConfigService) => {
                    'ngInject';
                    return adpConfigService.retrieveAdpImportDefinitions();
                },
                defaultFormat: (adpConfigService: AdpConfigService) => {
                    'ngInject';
                    return adpConfigService.retrieveDefaultImportDefinition(payrollID)
                }
            }
        }).result
            .then(($value: ModalResult) => {
                const nav = $state.go("^");
                $window.location.href = $value;
                return nav;
            })
            .catch(() => {
                $state.go("^");
            });
    },
    onExit: $uibModalStack => {
        'ngInject'
        $uibModalStack.dismissAll();
    },
    data: {
        permissionKey: "navigation:payrollProcessing"
    }
}

const routes: RouteDeclaration[] = [{
    // Redirect from the legacy state.
    state: "report.payrollProcessing",
    config: {
        name: "report.payrollProcessing",
        url: "^/report/payrollprocessing",
        redirectTo: "payroll.processing.dashboard"
    }
}, {
    state: "payroll.processing",
    config: {
        name: "payroll.processing",
        url: "/processing",
        redirectTo: "payroll.processing.dashboard"
    }
}, {
    state: "payroll.processing.dashboard",
    config: {
        name: "payroll.processing.dashboard",
        url: "",
        component: "apexPayrollProcessorDashboard",
        data: {
            permissionKey: "navigation:payrollProcessing"
        }
    }
}, ...addChildExtensions(adpImportFileExporterState, [
    // Support entering the state from the home dashboard.
    "root",
    // Support entering the state from the Payroll Entry
    "payroll.entry.edit.v2.summary",
    "payroll.entry.edit.v2.department",
    // Support entering from the standalone processing dashboard page.
    "payroll.processing.dashboard",
    // Support entering from legacy ADP Files page.
    "report.adpFiles"
])]

export const PayrollProcessingRoutingModule = angular
    .module("apex.mainApp.payroll.processing.routing", [])
    .run(configureStates(routes))
    .name;

